import { Component, OnChanges, OnDestroy, EventEmitter, Input, Output, ViewChild, QueryList, ViewChildren, OnInit } from '@angular/core';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageEvaluationService } from '../ph-bhp-feature-package-evaluation.service';
import { SopDetail } from '../Models/SopDetail';
import { PhBhpFilterComponent } from '../ph-bhp-filter/ph-bhp-filter.component';
import { forkJoin, Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';
import { AppConfig } from 'src/app/app.config';
import { PhBhpPdfComplianceMultiFilterComponent } from '../ph-bhp-pdf-compliance-multi-filter/ph-bhp-pdf-compliance-multi-filter.component';
import { PhBhpBarChartComponent } from '../ph-bhp-bar-chart/ph-bhp-bar-chart.component';
import cloneDeep from 'lodash/cloneDeep';
import { PhpBhpChartExportComponent } from '../php-bhp-chart-export/php-bhp-chart-export.component';

@Component({
  selector: 'lib-ph-bhp-sop-comments',
  templateUrl: './ph-bhp-sop-comments.component.html',
  styleUrls: ['./ph-bhp-sop-comments.component.css']
})
export class PhBhpSopCommentsComponent implements OnInit, OnChanges, OnDestroy {
  private static readonly INITIAL_FIELDS_PREDEFINED_COMMENTS = [
    { 'field': 'title', 'title': 'EVALUATION.TITLE', 'width': 160, 'group':'' }
  ];
  pageTitle: string;
  langSubscription: Subscription;
  compareCard = false;
  tempFilter;
  showCompareCard;
  @Input() userData;
  @Input() institutions = 0;
  @Input() isDesktop = true;
  @Input() filterDetails;
  isAdjustableHeight = true;
  @Output() childData = new EventEmitter();
  @ViewChildren(PhBhpBarChartComponent) charts: QueryList<PhBhpBarChartComponent>;

  @ViewChild('exportTag', { static: true }) exportTag: PhpBhpChartExportComponent;
  @ViewChild('compliance', { static: true }) compliance: PhBhpPdfComplianceMultiFilterComponent;
  @ViewChild('exportData') exportData;
  @ViewChildren(PhBhpFilterComponent) filters: QueryList<PhBhpFilterComponent>;
  @ViewChild('multiselect', { static: true }) multiselect: any;
  initFlag = true;
  noDataFound: boolean = false;

  selectedCommentID: string = "";
  selectedCommentName: string = "";
  isCallFor;
  sopIDs: Array<any> = [];
  sopDetail: Array<SopDetail>;
  tempSopDetail: SopDetail[];
  quickComments: Array<any>;
  userId;
  roleId;
  data;
  isSavedFromEvaluation: boolean;
  complianceType;
  pageInfo = {
    items: 'EVALUATION.COMMENTS',
    itemsPerPageLabel: 'EVALUATION.PER_PAGE.COMMENTS'
  };
  fieldComments: Array<any> = [
    { 'field': 'title', 'title': 'EVALUATION.SOP_TITLE' },
  ];

  appName = '';
  translationKeys: typeof TranslationKeys = TranslationKeys;
  commentTranslations;
  filterIndices: number[] = [0];

  public clickImageBtn = false;
  public clickExcelBtn = false;
  public clickPdfBtn = false;
  evaluationLoaded: boolean = false;
  isEvaluationTable: boolean = true;

  isUserFilterSetted: boolean = false;
  userHasFilter: boolean = false;
  results:any = [];
  userFilters: any;
  sopFilters: any[] = [];
  multiSelectText: string = '';

  constructor(
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService,
    public config: AppConfig) {

    this.pageTitle = this.layoutService.translateText('EVALUATION.COMMENTS_SOP_REPORT');
  }

  ngOnInit(): void {

    this.userId = this.userData.userId;
    this.roleId = this.userData.roleName.roleId;

    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      for(let i = 0; i < this.charts.length; i++){
        let chart = this.charts.get(i);
        chart.chartOptions.valueAxis.title.text = `${this.layoutService.translateText('SOP_MANAGEMENT.COMMENTS')} [%]`;
      }
      this.quickComments.forEach((comment) => {

      })

      this.pageTitle = this.layoutService.translateText('EVALUATION.COMMENTS'); //CONFLICT:this title set was only on phase2
      this.evaluate(true);
      this.layoutService.showLoader = false;
    });
  }

  ngOnDestroy() {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

  ngOnChanges() {
    this.layoutService.showLoader = true;
    let requestsArray = [];

    requestsArray.push(this.evaluationService.getSOPDetails(this.userData.userId));

    var roleId = this.userData.roleName.roleId
    if (roleId == 2) {
      this.institutions = 0;
    }
    if (roleId == 1) {
      requestsArray.push(this.evaluationService.getPredefinedComments());
    } else {
      requestsArray.push(this.evaluationService.getPredefinedCommentsListForObservation(this.userData.country, this.config.institutions || 0));
    }

    forkJoin<[SopDetail[], any]>(requestsArray).subscribe(([sopsDetailsResponse, commentsResponse]) => {

      if (roleId == 1) {
          this.quickComments = commentsResponse.filter((comment) => !comment.isDeleted);
          this.selectedCommentName = this.layoutService.translateText('EVALUATION.All.COMMENTS');
      } else {
          this.quickComments = [];
          for (let i = 0; i < commentsResponse.length; i++) {
            if (commentsResponse[i].predefinedCommentID == 1) { commentsResponse[i].commentName = 'SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH'; }
            if (commentsResponse[i].predefinedCommentID == 2) { commentsResponse[i].commentName = 'SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH'; }
            if (commentsResponse[i].predefinedCommentID == 3) { commentsResponse[i].commentName = 'SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED'; }
            if (commentsResponse[i].predefinedCommentID == 4) { commentsResponse[i].commentName = 'SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED'; }
            if (commentsResponse[i].predefinedCommentID == 5) { commentsResponse[i].commentName = 'SOP_OBSERVATION.PROCESS_INTERRUPTED'; }
          }
          this.quickComments = commentsResponse.filter((comment) => !comment.isDeleted);
          this.selectedCommentName = this.layoutService.translateText('EVALUATION.All.COMMENTS');
      }

      this.sopDetail = sopsDetailsResponse;
      this.userHasFilter = false;
      this.sopDetail = this.sopDetail.sort((a, b) => this.compareSOPTitles(a, b));
      if (!this.isUserFilterSetted) {
        this.evaluationService.getUserHasSOPEvaluationFilter(this.userData.userId, 'comments').subscribe((userHasFilter) => {
          this.isUserFilterSetted = true;
          if(userHasFilter){
            this.userHasFilter = true;
            this.userFilters = JSON.parse(userHasFilter.filterList);
            this.userFilters = this.userFilters.Filters; // WATCH OUT, the property "Filters" (with S) is for backward compatibility
            setTimeout(() => { this.initComponent(); });
          }else{
            this.userFilters = [];
            this.noDataFound = true;
            this.filters.get(0).showFilter(true);
            this.compliance.resultsLoader.next([{}]);
          }
        }, (error) => { }, () => { this.layoutService.showLoader = false; });
      } else {
        setTimeout(() => { this.initComponent(true); });
      }
    });
  }

  initComponent(isNewFilter = false) {

    if (this.userFilters && this.userFilters.length > 0) {
      this.userFilters.forEach((filter, idx) => {
        if (!filter.filterName || filter.filterName.trim() === "") {
          filter.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (idx + 1);
        }
      });
      this.filterIndices = this.userFilters.map((_, index) => index);
      this.showCompareCard = this.filterIndices.length > 1;
    }

    if (this.userData) {
      for(let i = 0; i < this.charts.length; i++){
        let chart = this.charts.get(i);
        chart.chartOptions.valueAxis.title.text = `${this.layoutService.translateText('SOP_MANAGEMENT.COMMENTS')} [%]`;
      }

      this.compliance.showFilter = true;
      this.compliance.complianceTitle = this.pageTitle;
      this.compliance.isObserve = false;
      this.compliance.roleId = this.roleId;
      this.compliance.fillWith = '0';

      this.loadFiltersInfo();

      if (this.userFilters && this.userFilters.length >= 2 && this.isDesktop) {
        this.showCompareCard = this.filterIndices.length > 1;
        this.compliance.showCompareCard = this.showCompareCard;
        this.tempFilter = this.userFilters;
      }

      this.evaluate(true, true);

    }
  }

  evaluate(getResults, iniatilize?) {

    this.printConfig();

    this.data = {
      commentsIDs: this.selectedCommentID,
      sopiDs: "",
      filters: [],
      isBenchMark: true
    }

    if (this.sopIDs.length == 0) {
      if(this.sopDetail){
        this.sopDetail.forEach((sop) => {
          this.data.sopiDs += sop.sopid + ",";
        })
        this.data.sopiDs = this.data.sopiDs.slice(0, -1);
      }
    } else {
      let sop = this.sopIDs;
      sop.forEach(element => {
        this.data.sopiDs += element.sopid + ",";
      });
      this.data.sopiDs = this.data.sopiDs.slice(0, -1);
    }

    if (this.selectedCommentID == "") {
      if (this.quickComments) {
        this.quickComments.forEach((comment) => {
          this.data.commentsIDs += comment.predefinedCommentID + ","
        })
        this.data.commentsIDs = this.data.commentsIDs.slice(0, -1);
      }
    }

    if(iniatilize){
      this.data.filters = this.userFilters;
    }else{
      this.filters.forEach((filter) => {
        let filterData: any = {
          startDate: filter.range.start,
          endDate: filter.range.end,
          instutionIDs: "",
          departmentID: "",
          wardID: "",
          professionalCategoryID: "",
          subprofessionalCategoryID: "",
          countryID: 0
        };
        if (this.roleId == 1 && filter.setCountry != 0) {
          filterData.countryID = filter.setCountry.countryID
        }

        filterData = filter.assignData(filterData);
        this.data.filters.push(filterData);
        if(filterData.multiSelectName){
          this.multiSelectText = filterData.multiSelectName;
        }
      });


    }
    this.userHasFilter = true;
    if (getResults == true) {
      this.getObservationsMultiFiltersByComments(this.userId, this.data);
    } else if (getResults == false) {
      this.saveObservationsFilterByComments(this.userId, this.data);
    }
  }

  async loadFiltersInfo(){
    // need wait for the filter component to be initialized
    setTimeout(() => {
      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if(this.roleId==1){
          filterComponent.setSAFilter(filter, true);
        }else{
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID,'','', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          if (filterComponent.wardListLoaded && filterComponent.wardListLoaded.length > 0) {
            filterComponent.onWardChange(filterComponent.wardListLoaded.find(ward => ward.wardID == filter.wardID));
          }

          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.SubprofessionalCategoryID, true);
          if(filter.multiselect){
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }

      });
    }, 500);
  }

  printConfig() {
    if (this.sopIDs.length == 0) {
      this.compliance.SOPList = undefined;
      this.compliance.SOPName = this.layoutService.translateText("EVALUATION.All.SOP");
    } else {
      this.compliance.SOPList = this.sopIDs;
      this.compliance.SOPName = undefined;
    }
  }


  filterCompare() {
    if (!this.userHasFilter) {
      this.filters.get(0).showFilter(true);
      return;
    }

    this.compareCard = false;

    if (this.filterIndices.length < 6) {
      this.filterIndices.push(this.filterIndices.length);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    this.layoutService.showLoader = true;
    setTimeout(() => {
      var filters = this.filters.toArray();
      filters[filters.length - 1].setInfoFromFilter(cloneDeep(filters[filters.length - 2]));
      this.layoutService.showLoader = false;
    }, 500);
  }

  emitData(valve) {
    this.childData.emit(valve);
  }

  getObservationsMultiFiltersByComments(userID, data) {
    this.complianceType = "Comments";
    this.isSavedFromEvaluation = true;
    this.isCallFor = "empty";
    this.layoutService.showLoader = true;
    this.evaluationService.getObservationsMultiFiltersByComments(userID, this.complianceType, this.isCallFor, this.isSavedFromEvaluation, data).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      this.buildChart(res.sopObservationPredefinedCommentsMainList, res.sopObservationFreeTextCommentsList);
    })
  }

  saveObservationsFilterByComments(userID, data) {
    this.complianceType = "Comments";
    this.isSavedFromEvaluation = false;
    this.isCallFor = "empty";
    this.layoutService.showLoader = true;
    var selectedSeries = JSON.stringify(Array.from(this.selectedSeries))
    this.data.selectedSeries = selectedSeries;
    this.evaluationService.getObservationsMultiFiltersByComments(userID, this.complianceType, this.isCallFor, this.isSavedFromEvaluation, data).subscribe((res: any) => {
      this.layoutService.showSuccess(this.layoutService.translateText('EVALUATION.SUCCESSFULLY_SAVED_SUMMARISED_REPORT'));
      this.layoutService.showLoader = false;
    })
  }

  ngAfterViewChecked() {
    if (this.tempFilter) {
      let tempFilter = this.tempFilter;
      this.tempFilter = undefined;

      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if(this.roleId==1){
          filterComponent.setSAFilter(filter, true);
        }else{
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID, '','', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.SubprofessionalCategoryID, true);
          if(filter.multiselect){
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }
      });
    }
  }

  buildChart(res, res1) {
    const colors = [
      "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300",
    ];
    res = this.adjustResponseForEnvironment(res);
    res = this.filterBenchmarkDataIfWardIsSelected(res);

    let chart: PhBhpBarChartComponent;

    this.results = [];
    res.forEach(result => {
      if(result.sopObservationCommentsResultSets.length > 0){
        let id = result.filterType || 'single';
        if(this.results.findIndex(r => r.id === id) === -1){
          this.results.push(
            {
              id, sopObservationCommentsResultSets: [],
              gridData: [],
              gridDataFreeText:[],
              fields: [...PhBhpSopCommentsComponent.INITIAL_FIELDS_PREDEFINED_COMMENTS],
              fieldsFreeText: [...this.fieldComments],
              noDataFound: true
            });
        }
      }
    });

    this.compliance.resultsLoader.next(Object.assign([], this.results));

    setTimeout(() => {

      res.forEach((filterResults: any, index) => {

        let chartId = filterResults.filterType || 'single';
        let chartIndex = this.results.findIndex(r => r.id === chartId);
        chart = this.charts.get(chartIndex);
        let gridData:any[] = this.results[chartIndex].gridData;
        let gridDataFreeText:any[] = this.results[chartIndex].gridDataFreeText;
        let fields = this.results[chartIndex].fields;
        // let fieldsFreeText = this.results[chartIndex].fieldsFreeText;


        let data = JSON.parse(JSON.stringify(chart.chartOptions));
        let dataSet = 0;
        let dataSetsName = this.layoutService.translateText('EVALUATION.DATA_SETS');

        // Initialize only first iteration of the chart
        if(!data.setId){
          data.nextIndex = 0;
          data.categoryAxis.categories = [];
          data.categoryAxis.categoryOffset = [];
          data.series = [];
          data.seriesIdentifier = [];
        }

        let filterCount: number = 0;
        let benchmarkCount: number = 0;


        dataSet = 0;
        data.series[data.nextIndex] = { data: [], name: [], dataOffset:[] , serieIndex: index};
        data.series[data.nextIndex].color = colors[index];
        data.seriesIdentifier[data.nextIndex] = [];
        chart.chartId = chartId;

        if (!filterResults.sopObservationCommentsResultSets?.every(c=> c.noData)) {
          this.results[chartIndex].noDataFound = false;
          this.noDataFound = false;
          chart.noDataFound = false;
        }

        filterResults.sopObservationCommentsResultSets.forEach((filterResult: any) => {

          let commentFilter = filterResult;
          let totalObservations= 0;
          data.series[data.nextIndex].dataSetId = commentFilter.id;

          filterResult.list.forEach((allCommentsResult) => {
            allCommentsResult.sopObservationPredefinedCommentsList.forEach((comment) => {

              let title = comment.commentName;
              // translate predefined comments by Id
              switch (comment.predefinedCommentID) {
                case 1:
                  title = this.layoutService.translateText('SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH');
                  break;
                case 2:
                  title = this.layoutService.translateText('SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH');
                  break;
                case 3:
                  title = this.layoutService.translateText('SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED');
                  break;
                case 4:
                  title = this.layoutService.translateText('SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED');
                  break;
                case 5:
                  title = this.layoutService.translateText('SOP_OBSERVATION.PROCESS_INTERRUPTED');
                  break;
              }
              comment.commentName = title;
              let commentsPercentage = (filterResult.noData && comment.predefinedCommentsPercentage == 0) ? 'NODATA' : comment.predefinedCommentsPercentage;
              totalObservations = comment.totalObservations;
              data.series[data.nextIndex].data.push(commentsPercentage);
              data.series[data.nextIndex].dataOffset.push({id: title, setId: commentFilter.id, value: commentsPercentage});
              data.seriesIdentifier[data.nextIndex].push({id: title, setId: commentFilter.id});
              if(commentFilter.id >= 0 && commentFilter.name){
                title += " / " +this.layoutService.translateText(commentFilter.name);
              }
              title = title ? title : comment.commentName;
              if (!data.categoryAxis.categories.includes(title)) {
                data.categoryAxis.categories.push(title);
                data.categoryAxis.categoryOffset.push({id: comment.commentName, setId: commentFilter.id});
              }
            });

          });
          // NOTE: every comment of the list has the same totalObservations, the count must be update outside the loop
          dataSet += totalObservations;
        })

        let maxLength =  data.categoryAxis.categoryOffset.length
        const combinedData = data.series.map(() => new Array(maxLength).fill(null));

        data.series.forEach((item, serieIndex) => {
          item.dataOffset.forEach((value, index) => {
            let indexOffset = data.categoryAxis.categoryOffset.findIndex(offset => offset.id === value.id && offset.setId === value.setId);
            combinedData[serieIndex][indexOffset] = value.value;
          });
        });

        for (let i = 0; i < combinedData.length; i++) {
          data.series[i].data = combinedData[i];
        }


        data.series[data.nextIndex].name = [`${this.data.filters && this.data.filters[data.series[data.nextIndex].serieIndex] ? this.data.filters[data.series[data.nextIndex].serieIndex].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (data.series[data.nextIndex].serieIndex + 1)} - ${dataSet} ${dataSetsName}`];
        data.series[data.nextIndex].filterName = [`${this.data.filters && this.data.filters[data.series[data.nextIndex].serieIndex] ? this.data.filters[data.series[data.nextIndex].serieIndex].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (data.series[data.nextIndex].serieIndex + 1)}`];
        data.series[data.nextIndex].filterNum = data.series[data.nextIndex].serieIndex+1;

        data.categoryAxis.rotation = 0;
        data.categoryAxis.maxDivisions = 10;
        data.setId = chartId;
        data.nextIndex++;
        chart.chartOptions = data;
        chart.chartDatamani();

        if (res && res.length > 0) {

          gridData = Object.assign([], gridData);
          gridDataFreeText = Object.assign([], gridDataFreeText);

          if (filterResults && !filterResults.isBenchMark) {
            filterResults.sopObservationCommentsResultSets.forEach(predefinedResultsList => {
              let predefinedCommentsList = predefinedResultsList.list[0].sopObservationPredefinedCommentsList;
              let freeTextCommentsList = predefinedResultsList.list[0].sopObservationFreeTextCommentsList;
              let multiName = '';
              let elementId = '';
              if(filterResults.filterType && filterResults.filterType != 'single'){
                multiName = predefinedResultsList.name;
                elementId = predefinedResultsList.id;
                if(predefinedResultsList.list.length == 0){
                  multiName = 'EVALUATION.NO_DATA'
                  elementId = 'nodata';
                }
                fields.push(
                  { 'field': `totalTouchedCommentsforfilter${index + 1}_${elementId}`, 'title': this.layoutService.translateText('EVALUATION.TOTAL.NUMBER_TOUCHED_COMMENTS'), 'group': `${this.data.filters && this.data.filters[index] ? this.data.filters[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}`, 'multiName':multiName },
                  { 'field': `totalObservationsforfilter${index + 1}_${elementId}`, 'title': this.layoutService.translateText('EVALUATION.TOTAL.AMOUNT_OBSERVATION'), 'group': `${this.data.filters && this.data.filters[index] ? this.data.filters[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}`, 'multiName':multiName },
                  { 'field': `predefinedCommentsPercentageforfilter${index + 1}_${elementId}`, 'title': this.layoutService.translateText('EVALUATION.TOUCHED_COMMENTS_PERCENT'), 'group': `${this.data.filters && this.data.filters[index] ? this.data.filters[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}`, 'multiName':multiName }
                );
                // FreeText table disabled
                // fieldsFreeText.push(
                //   { 'field': `commentName${index + 1}_${elementId}`, 'title': this.layoutService.translateText('EVALUATION.FREE_TEXT_COMMENTS'), 'group': `EVALUATION.FILTER${index + 1}`, 'multiName':multiName }
                // );
                predefinedCommentsList.forEach((item, i) => {
                  let comment = gridData.find(gd => item.predefinedCommentID === gd.predefinedCommentID);
                  let commentsPercentage = (predefinedResultsList.noData && item.predefinedCommentsPercentage == 0) ? 'N/A' : item.predefinedCommentsPercentage;
                  if (!comment) {
                    item[`totalTouchedCommentsforfilter${index + 1}_${predefinedResultsList.id}`] = item['totalTouchedComments'];
                    item[`totalObservationsforfilter${index + 1}_${predefinedResultsList.id}`] = item['totalObservations'];
                    item[`predefinedCommentsPercentageforfilter${index + 1}_${predefinedResultsList.id}`] = commentsPercentage;
                    item.title = item['commentName'];
                    delete item.commentName;
                    gridData.push(item);
                  }else{
                    comment[`totalTouchedCommentsforfilter${index + 1}_${predefinedResultsList.id}`] = item['totalTouchedComments'];
                    comment[`totalObservationsforfilter${index + 1}_${predefinedResultsList.id}`] = item['totalObservations'];
                    comment[`predefinedCommentsPercentageforfilter${index + 1}_${predefinedResultsList.id}`] = commentsPercentage;
                  }
                });
                // FreeText table disabled
                // freeTextCommentsList.forEach((fcItem, i) => {
                //   let freeComment = gridDataFreeText.find(gd => fcItem.title === gd.title);
                //   if (!freeComment) {
                //     fcItem[`commentName${index + 1}_${predefinedResultsList.id}`] = fcItem['commentName'];
                //     fcItem.title = fcItem['title'];
                //     delete fcItem.commentName;
                //     gridDataFreeText.push(fcItem);
                //   }else{
                //     fcItem[`commentName${index + 1}_${predefinedResultsList.id}`] = fcItem['commentName'];
                //   }
                // });

              }else{
                fields.push(
                  { 'field': `totalTouchedCommentsforfilter${index + 1}`, 'title': this.layoutService.translateText('EVALUATION.TOTAL.NUMBER_TOUCHED_COMMENTS'), 'group': `${this.data.filters && this.data.filters[index] ? this.data.filters[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}` },
                  { 'field': `totalObservationsforfilter${index + 1}`, 'title': this.layoutService.translateText('EVALUATION.TOTAL.AMOUNT_OBSERVATION'), 'group': `${this.data.filters && this.data.filters[index] ? this.data.filters[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}` },
                  { 'field': `predefinedCommentsPercentageforfilter${index + 1}`, 'title': this.layoutService.translateText('EVALUATION.TOUCHED_COMMENTS_PERCENT'), 'group': `${this.data.filters && this.data.filters[index] ? this.data.filters[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}` },
                );
                // FreeText table disabled
                // fieldsFreeText.push(
                //   { 'field': `commentName${index + 1}`, 'title': this.layoutService.translateText('EVALUATION.FREE_TEXT_COMMENTS'), 'group': `EVALUATION.FILTER${index + 1}` }
                // );
                predefinedCommentsList.forEach((item, i) => {
                  let commentsPercentage = (predefinedResultsList.noData && item.predefinedCommentsPercentage == 0) ? 'N/A' : item.predefinedCommentsPercentage;
                  let comment = gridData.find(gd => item.predefinedCommentID === gd.predefinedCommentID);
                  if (!comment) {
                    item[`totalTouchedCommentsforfilter${index + 1}`] = item['totalTouchedComments'];
                    item[`totalObservationsforfilter${index + 1}`] = item['totalObservations'];
                    item[`predefinedCommentsPercentageforfilter${index + 1}`] = commentsPercentage;
                    item.title = item['commentName'];
                    delete item.commentName;
                    gridData.push(item);
                  }else{
                    comment[`totalTouchedCommentsforfilter${index + 1}`] = item['totalTouchedComments'];
                    comment[`totalObservationsforfilter${index + 1}`] = item['totalObservations'];
                    comment[`predefinedCommentsPercentageforfilter${index + 1}`] = commentsPercentage;
                  }
                });
                // FreeText table disabled
                // freeTextCommentsList.forEach((fcItem, i) => {
                //   let freeComment = gridDataFreeText.find(gd => fcItem.title === gd.title);
                //   if (!freeComment) {
                //     fcItem[`commentName${index + 1}`] = fcItem['commentName'];
                //     fcItem.title = fcItem['title'];
                //     delete fcItem.commentName;
                //     gridDataFreeText.push(fcItem);
                //   }else{
                //     fcItem[`commentName${index + 1}`] = fcItem['commentName'];
                //   }
                // });
              }
            });

          }
        }

        this.results[chartIndex].gridData = gridData;
        this.results[chartIndex].fields = fields;
        this.results[chartIndex].resultChart = chart;

        // freeText table disabled
        // this.results[chartIndex].gridDataFreeText = gridDataFreeText;

        this.compliance.resultsLoader.next(Object.assign([], this.results));
        if (this.exportTag) {
          this.exportTag.results = Object.assign([], this.results);
        }

        setTimeout(() => {
          let complianceChart = this.compliance.charts.get(chartIndex);
          if(complianceChart){
            complianceChart.chartDatamani();
          }
          this.compliance.setComplianceFields(this.results[chartIndex], 6, 3);
          this.compliance.setFilters(this.filters.toArray());
        }, 500);
      });

      this.evaluationLoaded = true;
      setTimeout(() => { this.initializeFilters(); }, 1000);

    }, 1000);
  }

  initializeFilters() {

    this.selectedSeries.clear();
    this.filters.forEach((filter, index) => {
      filter.visible = true;
    });

    this.evaluationService.getSOPEvaluationSeries(this.userId, "Comments").subscribe((selectedSeries: any) => {

      this.layoutService.showLoader = false;
      if (!selectedSeries || selectedSeries.selectedSeries == null) {
        this.layoutService.showLoader = false;
        return;
      }

      if (!selectedSeries || selectedSeries.selectedSeries == null) return;

      let chartSeries = JSON.parse(selectedSeries.selectedSeries);

      chartSeries.forEach(serie => {
        // block for backward compatibility
        if(typeof serie === 'number'){
            this.charts.forEach((chart) => {
              this.compliance.toggleVisibility(chart.chartId, {index: serie });
              chart.internalToggleSerie({ index: serie });
            });
        }else{
          let chart = this.charts.find(c => c.chartId === serie.chartId);
          if(!chart) return;
          chart.internalToggleSerie({ index: serie.series });
          this.compliance.toggleVisibility(chart.chartId, {index: serie.series });
          this.filters.forEach((filter, index) => {
            if (index != serie.series) return;
            if (filter.visible == undefined) filter.visible = true;
            filter.visible = !filter.visible;
          });
        }
      });
    });
  }

  compareSOPTitles(a, b) {
    var aTitleTranslated = this.getSOPTranslation(a.title);
    var bTitleTranslated = this.getSOPTranslation(b.title);
    if (aTitleTranslated < bTitleTranslated) return -1;
    if (aTitleTranslated > bTitleTranslated) return 1;
    return 0;
  }

  getSOPTranslation(sopTrlID) {
    return this.layoutService.translateText(sopTrlID, '');
  }

  exportAs() {
    this.clickImageBtn = true;
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  downloadKendoPDF() {
    this.clickPdfBtn = true;
  }

  resetExportAs(value: 'image' | 'excel' | 'pdf') {
    switch (value) {
      case 'image':
        this.clickImageBtn = false;
        break;
      case 'excel':
        this.clickExcelBtn = false;
        break;
      case 'pdf':
        this.clickPdfBtn = false;
        break;
    }
  }

  resetSOPFilter(isMultifilter: boolean = false) {
    this.multiselect.reset();
    this.sopIDs = [];
    if (isMultifilter) {
      this.layoutService.showLoader = true;
      this.evaluate(true);
    }
  }

  onCommentChange(comment, evaluate: boolean = true) {
    if (comment != 0) {
      this.selectedCommentID = comment.predefinedCommentID;
      this.selectedCommentName = comment.commentName;
    } else {
      this.selectedCommentID = "";
      this.selectedCommentName = this.layoutService.translateText('EVALUATION.All.COMMENTS');
    }
    if(evaluate){
      this.evaluate(true);
    }
  }


  adjustResponseForEnvironment(res) {
    if (!this.isDesktop && res.length >= 2) {
      let spliceCount = 0;
      let idx = 1;
      res.forEach((processComplianceArray: any, index) => {
        if (index === 1) {
          if (processComplianceArray.isBenchMark === false) {
            spliceCount++;
          } else {
            idx = 2;
          }
        } else if (index === 2 || index === 3) {
          spliceCount++;
        }
      });
      return res.splice(idx, spliceCount);
    }
    return res;
  }

  filterBenchmarkDataIfWardIsSelected(res): any {
    if (this.shouldHideBenchmarkData())
      return res.filter(item => !item.isBenchMark);
    else
      return res;
  }

  shouldHideBenchmarkData() {
    return true;
  }

  anyWardIsSelected() {
    for (let filterComponent of this.filters.toArray()) {
      if (filterComponent.isWardSelected()) {
        return true;
      }
    }
    return false;
  }

  onFilterRemoved(filterIndexToRemove: number) {
    const index = this.filterIndices.indexOf(filterIndexToRemove);

    if (index !== -1) {
      this.filterIndices.splice(index, 1);
      this.userFilters.splice(index, 1);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    if (this.userHasFilter) {
      this.layoutService.showLoader = true;
      setTimeout(() => { this.evaluate(true); }, 1000);
    }
  }

  resetFilters() {
    this.resetSOPFilter();
    this.onCommentChange(0, false);
    this.filterDetails = [this.filterDetails[0]];
    this.filterIndices = [0];
    this.filters.toArray()[0].resetFilter(true);
    this.layoutService.showLoader = true;
    var seriesData = {
      userId: this.userId,
      complianceType: "Comments",
      selectedSeries: null
    };

    this.evaluationService.updateSOPEvaluationSeries(seriesData).subscribe(() => {
      setTimeout(() => { this.evaluate(true); }, 1500);
    }, () => { }, () => { });


  }

  originalFields: any[] = null;
  selectedSeries: Set<number> = new Set();


  onSeriesClick(serie: any) {

    let chart = this.charts.find( c => c.chartId == serie.chartId);
    chart.series.get(serie.index).options.visible = serie.visible;

    this.filters.forEach((filter, index) => {
      if (index != serie.index) return;
      if (filter.visible == undefined) filter.visible = true;
      filter.visible = !filter.visible;
    });

    this.compliance.toggleVisibility(serie.chartId,serie);

    let visibilitySeries = [];

    this.charts.forEach((chart) => {
      let c = {
        chartId: chart.chartId,
        series: chart.series.map((s, index) => ({ series: s, index }))
                            .filter(s => s.series.options.visible === false)
                            .map(s => s.index)
      }
      visibilitySeries.push(c);
    })

    var seriesData = {
      userId: this.userId,
      complianceType: "Comments",
      selectedSeries: JSON.stringify(visibilitySeries)
    };

    this.evaluationService.updateSOPEvaluationSeries(seriesData).subscribe(() => { }, () => { }, () => { });
  }

  onFilterSaved() {
    // Buscar nombres duplicados y renombrar los duplicados
    const renamedFilters: string[] = [];
    var filters = this.filters.toArray();
    // Recorre desde el último hasta el primero
    for (let i = filters.length - 1; i >= 0; i--) {
      const currentName = filters[i].filterName?.trim() || '';
      for (let j = 0; j < filters.length; j++) {
        if (i !== j && currentName && currentName === (filters[j].filterName?.trim() || '')) {
          // Si hay coincidencia, renombra el actual
          const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (i + 1);
          filters[i].filterName = translatedFilterName;
          filters[i].setFilterName = translatedFilterName;          
          renamedFilters.push(translatedFilterName);
          break;
        }
      }
    }

    if (renamedFilters.length > 0) {
        const f = renamedFilters[renamedFilters.length - 1];
        const msg = `${this.layoutService.translateText('EVALUATION.FILTER_DUPLICATED_NAME')} '${f}'.`;
        this.layoutService.showWarning(msg);
    }
    this.evaluate(true);
  }

  onRefreshClick(noDataFound: boolean) {
    if (noDataFound) {
      return;
    }

    this.evaluate(true);
  }

  saveSummarisedReport() {
    if (this.userHasFilter) {
      this.evaluate(false);
    }
  }

  onMultiselectChange(event: Event) {
    this.layoutService.showLoader = true;
    this.evaluate(true);
  }

  trackLoop(index: number, item: any) {
    return item;
  }

}
